import React from "react";
import {
    Leaf,
    ShieldCheck,
    HelpCircle,
    BatteryCharging,
    Cloud,
    CircleDot,
} from "lucide-react";

const products = [
    {
        title: "Vapes",
        category: "Age Restricted",
        description: "High-quality disposable Mübar vapes in a variety of flavours.",
        image: "/images/berries-vape.png",
        icon: ShieldCheck,
        tags: ["Kuba-700", "Variety", "Smooth"],
        link: "https://mu-bar.es/",
    },
    {
        title: "Nicotine Pouches",
        category: "Age Restricted",
        description: "Premium Nordic nicotine pouches from Greatest. Discreet and convenient.",
        image: "/images/greatest.png",
        icon: ShieldCheck,
        tags: ["Tobacco-Free", "Discreet", "Cold-Dry"],
        link: "https://greatestpouch.com/",
    },
    {
        title: "Fresh Mints",
        category: "Guest Essentials",
        description: "Instantly fresh. Perfect for any moment.",
        image: "/images/fresh-mints.png",
        icon: Leaf,
        tags: ["Sugar Free", "Pocket", "Fresh"],
    },
    {
        title: "Condoms",
        category: "Protection",
        description: "Trusted protection. Discreet and convenient.",
        image: "/images/condoms.png",
        icon: ShieldCheck,
        tags: ["Trusted", "Discreet", "Reliable"],
    },
    {
        title: "Hair Ties",
        category: "Convenience",
        description: "Small things that make a big difference.",
        image: "/images/hair-ties.png",
        icon: CircleDot,
        tags: ["Strong", "Durable", "Essential"],
    },
    {
        title: "Mini Chargers",
        category: "Power",
        description: "Stay powered and keep the night going.",
        image: "/images/mini-charger.png",
        icon: BatteryCharging,
        tags: ["Portable", "Fast", "Reliable"],
    },
    {
        title: "Need Something Else?",
        category: "Custom Items",
        description: "Tell us what your venue needs - we can stock it.",
        image: "/images/custom-items.png",
        icon: HelpCircle,
        tags: ["Flexible", "Venue", "Custom"],
    },
];

const ProductsSection = () => {
    return (
        <section id="products" className="py-20 lg:py-24 bg-slate-50">
            <div className="max-w-6xl mx-auto px-6 lg:px-8">
                {/* Header */}
                <div className="text-center max-w-3xl mx-auto mb-12">
                    <span className="inline-block px-4 py-1.5 bg-slate-200 text-slate-700 text-sm font-medium rounded-full mb-4">
                        Our Selection
                    </span>

                    <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-5">
                        Nightlife Essentials
                        <span className="text-blue-500">.</span>
                    </h2>

                    <p className="text-lg text-slate-600 leading-relaxed">
                        Curated products your guests need. Stocked, managed and ready for
                        every night.
                    </p>
                </div>

                {/* Grid */}
                <div className="grid md:grid-cols-2 gap-4">
                    {products.map((product) => {
                        const Icon = product.icon;

                        return (
                            <div
                                key={product.title}
                                className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
                            >
                                <div className="flex h-full">
                                    {/* Image */}
                                    <div className="w-[160px] bg-slate-50 flex items-center justify-center p-5 flex-shrink-0">
                                        <img
                                            src={product.image}
                                            alt={product.title}
                                            className="max-h-[110px] object-contain"
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className="flex-1 p-5">
                                        <div className="flex items-center gap-2 mb-2">
                                            <div className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center">
                                                <Icon className="w-4 h-4 text-blue-500" />
                                            </div>

                                            <span className="text-xs font-medium text-blue-500">
                                                {product.category}
                                            </span>
                                        </div>

                                        <h3 className="text-xl font-bold text-slate-900 mb-2">
                                            {product.title}
                                        </h3>

                                        <div className="mb-4">
                                            <p className="text-sm text-slate-600 leading-relaxed">
                                                {product.description}
                                            </p>

                                            {product.link && (
                                                <a
                                                    href={product.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-block mt-2 text-sm font-medium text-blue-600 hover:underline"
                                                >
                                                    Learn more →
                                                </a>
                                            )}
                                        </div>

                                        <div className="flex flex-wrap gap-2">
                                            {product.tags.map((tag) => (
                                                <span
                                                    key={tag}
                                                    className="px-2.5 py-1 bg-slate-100 text-slate-600 text-xs rounded-full"
                                                >
                                                    {tag}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ProductsSection;
